module.exports = __webpack_public_path__ + "img/flag_pt.73656912.jpg";